export default {
    key:'global',
    dashboard: {
        component:'MarketIndex',
        links: {
            sidebar:[
                {
                    icon:'fas fa-fw fa-tachometer-alt',
                    text:'Market Admins',
                    route:'/global_admin',
                    active:'marketadmins'
                },
                {
                    icon:'fas fa-user-cog',
                    text:'Market place',
                    route:'/gobal_admin_market',
                   
                },
                // {
                //     icon:'fas fa-sitemap',
                //     text:'Entities',
                //     route:'/admins/entities',
                //     active:'entities'
                // },
                // {
                //     icon:'fas fa-users',
                //     text:'Users',
                //     route:'/admins/users',
                //     active:'users'
                // },
                // {
                //     icon:'fa fa-user-cog',
                //     text:'settings',
                //     route:'/settings',
                //     active:'settings'
                // },
                
            ],
            mandate: {
                title:'Mandates',
                icon:'fas fa-braille',
                sublinks: [
                    {
                        text:'Organisations',
                        route:'/organisations/give_mandate',
                        active:'organisations'
                    },
                    {
                        text:'Agencies',
                        route:'/agencies/give_mandate',
                        active:'Agencies'
                    },
                    {
                        text:'Outlets',
                        route:'/outlets/give_mandate',
                        active:'outlets'
                    }
                ]
            }
        }
    }
}